import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-catalog-detail-save',
  templateUrl: './catalog-detail-save.component.html',
  styleUrls: ['./catalog-detail-save.component.scss']
})
export class CatalogDetailSaveComponent {

  constructor(public dialogRef: MatDialogRef<CatalogDetailSaveComponent>) {

  }

}
